import React, { useEffect, useState, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { AuthContext } from '../context/AuthContext';
import { MessageContext } from '../context/MessageContext';
//import { CirclePlus } from 'lucide-react'


function Home() {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [deleted, setDeleted] = useState(true);
  const [sessionId, setSessionId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, serverNotAvailable, loading: authLoading } = useContext(AuthContext);
  const { setMess } = useContext(MessageContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'm') { // Ctrl + M
        event.preventDefault();

        navigate('/test');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  if (authLoading) return <div>Загрузка...</div>;

  return (
    <>
    <section className="bg-gradient-to-br from-green-50 to-green-100 dark:from-gray-900 dark:to-gray-800 py-5 px-2 md:px-5 md:py-20 overflow-x-auto transition-all duration-500 font-[PingFang SC,Helvetica Neue,sans-serif]">
      <div className="container mx-auto px-4 ">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-green-600 dark:text-green-400 tracking-tight">
              Купить автомобиль самостоятельно
            </h1>
            <p className="text-lg mb-8 text-gray-700 dark:text-gray-300">
              Наша главная задача - сделать процесс покупки автомобиля из других стран прозрачнее и дешевле.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a href="#features" className="px-6 py-3 rounded-lg bg-green-500 text-white font-semibold shadow hover:bg-green-600 transition-colors duration-200 text-center">
                Читать дальше
              </a>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <img
				src="photo.jpg"
				alt="Покупка автомобиля"
				className="rounded-lg shadow-xl"
			/>
          </div>
        </div>
      </div>
    </section>
    <section id="features" className="py-20 bg-white dark:bg-gray-900 font-[PingFang SC,Helvetica Neue,sans-serif]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4 text-green-600 dark:text-green-400 tracking-tight">
            Привет!
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-gray-700 dark:text-gray-300">
            Мы рады, что ты зашел к нам. Скоро на этом месте будет система, с помощью которой ты сможешь купить автомобиль в Китае и других странах самостоятельно.
          </p>
        </div>
      </div>
    </section>
    </>
  )
};

export default Home
